<template>
	<div class="mb_40">
		<span class="error_icon ERRORGRAY mb_4"></span>
		<div class="body_m mb_40">
			<p>{{ $t('c2c.check.text2') }} <br />{{ $t('c2c.check.text3') }}</p>
		</div>
		<div v-if="sourceAsset.is_active === 'Y'" class="registration_box_wrap">
			<!--      계좌 없는 박스-->
			<div
				class="item_box"
				v-if="!sourceAccount"
				@click="$emit('createAccount', sourceAsset.seq)"
			>
				<div class="d_flex align_items_center">
					<span :class="'icon ' + sourceAsset.code"></span>
					<div class="coin_name">
						{{ sourceAsset.code + ' ' + sourceAsset.title }}
					</div>
				</div>
				<div class="value">
					<span class="icon ADD"></span>
					<p>{{ $t('c2c.check.text1') }}</p>
				</div>
			</div>
			<!--			계좌 있는 박스 class has 붙음 -->
			<div v-else class="item_box has">
				<div class="d_flex align_items_center">
					<span :class="'icon ' + sourceAccount.asset_code"></span>
					<div class="coin_name fc_white">
						{{ sourceAccount.asset_code + ' ' + sourceAccount.asset_title }}
					</div>
				</div>
				<div class="value">
					<p class="headline_s">{{ sourceAccount.balance }}</p>
					<span>{{ sourceAccount.asset_code }}</span>
				</div>
			</div>
		</div>
		<div v-if="targetAsset.is_active === 'Y'" class="registration_box_wrap">
			<!--      계좌 없는 박스-->
			<div
				class="item_box"
				v-if="!targetAccount"
				@click="$emit('createAccount', targetAsset.seq)"
			>
				<div class="d_flex align_items_center">
					<span :class="'icon ' + targetAsset.code"></span>
					<div class="coin_name">
						{{ targetAsset.code + ' ' + targetAsset.title }}
					</div>
				</div>
				<div class="value">
					<span class="icon ADD"></span>
					<p>{{ $t('c2c.check.text1') }}</p>
				</div>
			</div>
			<!--			계좌 있는 박스 class has 붙음 -->
			<div v-else class="item_box has">
				<div class="d_flex align_items_center">
					<span :class="'icon ' + targetAccount.asset_code"></span>
					<div class="coin_name fc_white">
						{{ targetAccount.asset_code + ' ' + targetAccount.asset_title }}
					</div>
				</div>
				<div class="value">
					<p class="headline_s">{{ targetAccount.balance }}</p>
					<span>{{ targetAccount.asset_code }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// import '@/assets/css/c2c.m.css';
import { mapGetters } from 'vuex';

export default {
	name: 'CheckAccount.m',
	emits: ['createAccount'],
	props: {
		sourceAssetSeq: {
			type: Number,
		},
		targetAssetSeq: {
			type: Number,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),
		sourceAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.sourceAssetSeq;
			});
		},
		targetAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.targetAssetSeq;
			});
		},
		sourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.sourceAssetSeq;
			});
		},
		targetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.targetAssetSeq;
			});
		},
	},
};
</script>
<style></style>
